// extracted by mini-css-extract-plugin
export default {"container":"innovationdetails_container__ZO8-1"};